import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock, Mail, Facebook, Instagram, Youtube, Twitter } from 'lucide-react';

const Footer = () => {
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Contact', path: '/contact' }
  ];

  const services = [
    'AC Installation',
    'AC Repair & Maintenance', 
    'Spare Parts Supply',
    '24/7 Emergency Service',
    'Annual Maintenance Contracts'
  ];

  const industries = [
    'Commercial Buildings',
    'Residential Properties',
    'Industrial Facilities',
    'Healthcare Centers',
    'Educational Institutions',
    'Hospitality Sector'
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-6">
              <div className="bg-gradient-to-r from-purple-600 to-blue-600 p-3 rounded-xl">
                <span className="text-white font-bold text-xl">NEBULA</span>
              </div>
              <div>
                <div className="text-white font-bold text-lg">Nebula Trading</div>
                <div className="text-gray-400 text-sm">Technical Services</div>
              </div>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Professional air conditioning and refrigeration services across Qatar. 
              Delivering precision, performance, and perfection in every project.
            </p>
            
            {/* Social Media */}
            <div className="flex space-x-4">
              <a href="#" className="bg-gray-800 hover:bg-purple-600 p-3 rounded-lg transition-colors duration-300">
                <Facebook size={20} />
              </a>
              <a href="#" className="bg-gray-800 hover:bg-purple-600 p-3 rounded-lg transition-colors duration-300">
                <Instagram size={20} />
              </a>
              <a href="#" className="bg-gray-800 hover:bg-purple-600 p-3 rounded-lg transition-colors duration-300">
                <Youtube size={20} />
              </a>
              <a href="#" className="bg-gray-800 hover:bg-purple-600 p-3 rounded-lg transition-colors duration-300">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white text-lg font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-purple-400 transition-colors duration-300 flex items-center"
                  >
                    <span className="w-1 h-1 bg-purple-400 rounded-full mr-3"></span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white text-lg font-bold mb-6">Our Services</h3>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service} className="text-gray-300 flex items-center">
                  <span className="w-1 h-1 bg-blue-400 rounded-full mr-3"></span>
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h3 className="text-white text-lg font-bold mb-6">Industries We Serve</h3>
            <ul className="space-y-2">
              {industries.map((industry) => (
                <li key={industry} className="text-gray-300 text-sm flex items-center">
                  <span className="w-1 h-1 bg-green-400 rounded-full mr-3"></span>
                  {industry}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Contact Info Bar */}
        <div className="py-8 border-t border-gray-700">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-center space-x-3">
              <div className="bg-purple-600 p-2 rounded-lg">
                <Phone size={16} />
              </div>
              <div>
                <p className="text-white font-semibold text-sm">24/7 Hotline</p>
                <a href="tel:+97470086090" className="text-gray-300 hover:text-purple-400 transition-colors">
                  +974 7008 6090
                </a>
              </div>
            </div>
            
            <div className="flex items-center space-x-3">
              <div className="bg-blue-600 p-2 rounded-lg">
                <MapPin size={16} />
              </div>
              <div>
                <p className="text-white font-semibold text-sm">Location</p>
                <p className="text-gray-300">Muaither, Doha - Qatar</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-3">
              <div className="bg-green-600 p-2 rounded-lg">
                <Clock size={16} />
              </div>
              <div>
                <p className="text-white font-semibold text-sm">Working Hours</p>
                <p className="text-gray-300">24/7 Emergency Service</p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <div className="bg-orange-600 p-2 rounded-lg">
                <Mail size={16} />
              </div>
              <div>
                <p className="text-white font-semibold text-sm">Email Us</p>
                <a href="mailto:info@nebulaqa.com" className="text-gray-300 hover:text-purple-400 transition-colors">
                  info@nebulaqa.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="py-6 border-t border-gray-700 text-center">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 Nebula Trading & Technical Services. All rights reserved.
            </p>
            <p className="text-gray-400 text-sm mt-2 md:mt-0">
              C.R. No: 84110 | Licensed AC Services Provider in Qatar
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;